import {ReportsRequestsService} from "../../services/reports-requests.service";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {
  reportDownload,
  reportDownloadSuccess,
  reportShareDestination,
  reportShareDestinationSuccess,
  reportShareMail,
  reportShareMailSuccess
} from "./report.actions";
import {exhaustMap, map, tap, withLatestFrom} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {showSnackbar} from "../snackbar/snackbar.actions";
import {AdRRequestParams} from "../../classes/ad-r-request-params";
import {Observable} from 'rxjs';
import {Serializer} from '../../interfaces/serializer';
import {Site} from '../../interfaces/site';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';
import {AppState} from '../store';
import {Store} from '@ngrx/store';

@Injectable()
export class ReportEffects {
  private readonly _dataSet$: Observable<Serializer<Site>> = this._store.select(selectSite);

  public readonly reportDownload$ = createEffect(() => this._actions$.pipe(
    ofType(reportDownload),
    tap(() => {
      // @ts-ignore
      gtag('event', 'report_download', {'event_category': 'report'});
    }),
    withLatestFrom(this._dataSet$),
    exhaustMap(([action, dataSet]: [TypedAction<string> & {params, format, reportData, separator}, Serializer<Site>]) => this._reportsRequestsS.exportFile(
      dataSet,
      {
        ...new AdRRequestParams(),
        ...action.params
      },
      action.format,
      action.reportData,
      action.separator
    )),
    map(() => reportDownloadSuccess())
  ));

  public readonly reportExportMail$ = createEffect(() => this._actions$.pipe(
    ofType(reportShareMail),
    withLatestFrom(this._dataSet$),
    exhaustMap(([action, dataSet]) => this._reportsRequestsS.exportMail(
      dataSet,
      {
        ...new AdRRequestParams(),
        ...action.params
      },
      action.format,
      action.reportId,
      action.emails,
      action.reportType,
      action.name
    )),
    exhaustMap(() => [
      reportShareMailSuccess(),
      showSnackbar({ message: 'export.report_sent' })
    ])
  ));

  public readonly reportExportDestination$ = createEffect(() => this._actions$.pipe(
    ofType(reportShareDestination),
    withLatestFrom(this._dataSet$),
    exhaustMap(([action, dataSet]) => this._reportsRequestsS.exportDestination(
      dataSet,
      {
        ...new AdRRequestParams(),
        ...action.params
      },
      action.format,
      action.reportId,
      action.destination,
      action.reportType,
      action.name
    )),
    exhaustMap(() => [
      reportShareDestinationSuccess(),
      showSnackbar({ message: 'export.report_sent' })
    ])
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _reportsRequestsS: ReportsRequestsService,
    private readonly _actions$: Actions
  ) {}

}
